import React, { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import { ProcessData, TimelineContainer } from 'domain/shared/timeline';
import { useShowContext } from 'framework/show';
import useEmployeesDashboardService from '../../useEmployeesDashboardService';
import ProcessItem from './components/ProcessItem';

const ProcessTimeline: React.FC = () => {
  const { data } = useShowContext();
  const { employeeAlias } = data.getData();
  const { getEmployeeProcesses } = useEmployeesDashboardService();
  const [processes, setProcesses] = useState<ProcessData[]>([]);
  const [loading, setLoading] = useState<boolean>(true);

  useEffect(() => {
    const fetchProcesses = async () => {
      try {
        setLoading(true);
        if (!employeeAlias) {
          throw new Error('Worker ID is required');
        }
        const res = await getEmployeeProcesses(employeeAlias);
        setProcesses(res);
      } finally {
        setLoading(false);
      }
    };
    if (employeeAlias) {
      fetchProcesses();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const renderContent = () => {
    if (loading) {
      return (
        <Box py={2} textAlign="center">
          <Typography variant="body1" color="textSecondary">
            Loading processes...
          </Typography>
        </Box>
      );
    }

    if (processes.length === 0) {
      return (
        <Box py={2} textAlign="center">
          <Typography variant="body1" color="textSecondary">
            There are no active processes
          </Typography>
        </Box>
      );
    }

    return processes.map(process => <ProcessItem key={process.processDefinition} process={process} />);
  };

  return (
    <TimelineContainer>
      <Typography variant="h4" color="primary" borderBottom="1px solid" borderColor="border.strong">
        Processes
      </Typography>
      {renderContent()}
    </TimelineContainer>
  );
};

export default ProcessTimeline;
